
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mon-compte/mon-profil",
      function () {
        return require("private-next-pages/mon-compte/mon-profil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mon-compte/mon-profil"])
      });
    }
  